<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'SessionLogs' : 'Deleted SessionLogs'
                "
              ></h3>
              <v-spacer></v-spacer>
              <!-- Therapy Session Filter Indicator -->
              <!-- <v-chip
                v-if="sessionFilterActive"
                color="primary"
                text-color="white"
                class="mr-2"
                closable
                @click:close="clearTherapySessionFilter"
              >
                <v-icon left small>mdi-filter</v-icon>
                Filtering: {{ filteredPatientName }}
              </v-chip> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <!-- <v-card-title v-if="session_logs.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelLoading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title> -->
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start">Patient Name</th>
                      <th class="text-start">Device Name</th>
                      <th class="text-start">Procedure Name</th>
                      <th class="text-start">Description</th>
                      <th class="text-start">Speed</th>
                      <th class="text-start">Unweighting %</th>
                      <th class="text-start">Lifted Weight</th>
                      <th class="text-start">Therapist Name</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody v-if="session_logs.length != 0">
                    <tr
                      v-for="(log, i) in session_logs"
                      :key="`log_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': session_logs.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="log.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Session Log is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="log.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Session Log is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.patient
                            ? log.therapy_session.patient.first_name
                            : " "
                        }}
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.device
                            ? log.therapy_session.device.model_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.procedure
                            ? log.therapy_session.procedure.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{ log.description || "" }}
                      </td>
                      <td>
                        {{ log.speed || "" }}
                      </td>
                      <td>
                        {{ log.unweighting_percentage || "" }}
                      </td>
                      <td>
                        {{ log.lifted_weight || "" }}
                      </td>
                      <td>
                        {{
                          log.therapy_session && log.therapy_session.created_by
                            ? log.therapy_session.created_by.first_name
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto mr-1"
                                color="info"
                                :to="`/session-logs/${$route.params.sessionId}/control-logs`"
                              >
                                <v-icon dark> mdi-console </v-icon>
                              </v-btn>
                            </template>
                            <span>View Control Logs</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "session_logsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        therapy_session_id: "",
      },
      sessionFilterActive: false,
      filteredPatientName: "",
      session_logs: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelLoading: false,
    };
  },
  computed: {
    serialNoStarting() {
      return (this.page - 1) * this.rowsPerPage + 1;
    },
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 250; // Mobile phones
        case "sm":
          return 300; // Tablets
        case "md":
          return 400; // Small laptops
        case "lg":
          return 500; // Desktop
        case "xl":
          return 600; // Large desktop
        default:
          return 400;
      }
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.checkForTherapySessionFilter();
    this.getData();
  },
  methods: {
    checkForTherapySessionFilter() {
      // Check if we're filtering by therapy session
      if (this.$route.query.therapy_session_id) {
        this.filter.therapy_session_id = this.$route.query.therapy_session_id;
        this.sessionFilterActive = true;
        this.filteredPatientName = this.$route.query.patient_name || "";
      }
    },
    clearTherapySessionFilter() {
      this.filter.therapy_session_id = "";
      this.sessionFilterActive = false;
      this.filteredPatientName = "";
      this.getData();
    },
    isDeletePage() {
      return this.$route.query.open_trash ? true : false;
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
        console.log("route params", this.$route.params.sessionId);
        
      if (this.$route.params.sessionId) {
        this.filter.therapy_session_id = this.decryptIt(this.$route.params.sessionId);
      } else {
        this.filter.therapy_session_id = "";
      }
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&therapy_session_id=" +
        this.filter.therapy_session_id;

      await axios
        .get(`session_logs?${query}`)
        .then((response) => {
          this.session_logs = response.data.data;
          this.count = response.data.count;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    async Delete_this(id) {
      await axios
        .post(`/session_logs/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async Restore_this(id) {
      await axios
        .post(`/session_logs/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async generateExcel() {
      this.isExcelLoading = true;
      try {
        const params = new URLSearchParams({
          search_keyword: this.filter.search_keyword || "",
          is_active: this.filter.is_active || "",
        });

        const response = await axios.get(`/session_logs/excel?${params}`, {
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `session_logs_${new Date().toISOString().split("T")[0]}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.log(error);
      } finally {
        this.isExcelLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.table-row-even {
  background-color: #f9f9f9;
}
.table-row-odd {
  background-color: white;
}
.sr_no {
  min-width: 85px;
}
</style>
